import React, { useState, useEffect } from "react";
import WarningModal from "../components-modals/WarningModal";
import Layout from "../Layout";
import Container from "../components-layout/Container";
import Header from "../components-layout/Header";
import { Transition } from "@headlessui/react";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ArrowUpTrayIcon,
  ListBulletIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import InputFile from "./components/InputFile";
import CirculosBancos from "./components/CirculosBancos";
import { fetchApi } from "../tools";
import { currentMMYY } from "../components-contabilidad-analisis/ReportsForm";
import { TableBody } from "flowbite-react/lib/esm/components/Table/TableBody";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ContabilidadArchivo = () => {
  const [modal, setModal] = useState({});
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);
  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const url2 = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
  //const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies
  const urlSeguridadApi = cookies.get("__urlSeguridad");
  const urlInvoice = cookies.get("__urlInvoiceApi");

  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const IdEmp = useSelector((state) => state.auth.IdEmp);

  const [fileBase64, setFileBase64] = useState();
  const [ciclo, setCiclo] = useState();
  const [mes, setMes] = useState();
  const [option, setOption] = useState();
  const [filter, setFilter] = useState();
  const [cuenta, setCuenta] = useState();
  const [banco, setBanco] = useState(2);
  const [loading, setLoading] = useState(false);
  const [dataNoCargados, setDataNoCargados] = useState([]);

  const [bancos, setBancos] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [nombreCuenta, setNombreCuenta] = useState("");

  const handleCuenta = (idCuenta, nombreCuenta) => {
    console.log(idCuenta);
    setCuenta(idCuenta);
    setNombreCuenta(nombreCuenta);
    //setFilter(parseInt(idCuenta.target.value));
  };
  const handleMes = (idMes) => {
    setFilter(idMes);
    let divididos = idMes.split("-");
    setMes(divididos[1]);
    setCiclo(parseInt(divididos[0]));
  };

  useEffect(() => {
    setCuenta("");
    setMes("");
    setBanco(2)
    setFilter(() => "");
  }, [option]);

  const handleSede = (sede, nombre) => {
    setCuenta("");
    //setFilter("")
    setBanco(sede);
  };

  const sendFile = async () => {
    setLoading(true);
    const res = await fetchApi({
      url: url + "/finanzas/loaderfiles",
      headers: headers,
      method: "POST",
      content: {
        Tipo: option, // 1 = Estado de cuenta, 2 = Facturación SAT
        IdBanco: banco.toString(),
        Cuenta: cuenta,
        fileBase64: fileBase64, // Base 64 del archivo
        IdEmp: IdEmp,
        HostName: "DEV07",
        IpHost: "131.107.1.235",
        OS: "Windows",
      },
    });
    setLoading(false);
    setOption("");
    setFilter("");
    setFileBase64("");
    if (res.msg.Error === "0") {
      res.msg?.DataNoCargada
        ? setDataNoCargados(res.msg.DataNoCargada)
        : setDataNoCargados([]);
      setModal({
        ok: true,
        show: true,
        msg: res.msg.Mensaje,
      });
    } else {
      setModal({
        ok: false,
        show: true,
        msg: "No se pudo cargar el archivo",
      });
    }
  };

  const getCuentas = async (banco) => {
    const res = await fetchApi({
      url: url + "/utils/busquedas",
      headers,
      content: {
        opcion: "CUENTAS",
        IdBanco: banco,
      },
    });
    setCuentas(res);
  };

  const getBancos = async () => {
    const res = await fetchApi({
      url: url + "/utils/busquedas",
      headers,
      content: {
        opcion: "BANCOS",
      },
    });
    setBancos(res);
  };

  useEffect(() => {
    getCuentas(banco);
    //setFilter("");
    setFileBase64("");
  }, [banco]);

  useEffect(() => {
    console.log(cuenta);
    //setFilter(cuenta?.IdCuenta);
  }, [cuenta]);

  useEffect(() => {
    getBancos();
  }, []);

  return (
    <>
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        width={dataNoCargados.length > 0 ? "" : "sm:w-full sm:max-w-sm"}
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon
              className={
                dataNoCargados.length > 0
                  ? "h-20 w-20 text-secundario mx-auto"
                  : "h-20 w-20 text-green-500 mx-auto"
              }
            />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title={"Aviso"}
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        {dataNoCargados.length > 0 && (
          <div className="w-full">
            <p className="text-gray-400 my-2">
              A continuación se muestran las boletas de hoy, las cuales no se
              cargaron en el estado de cuenta del sistema
            </p>
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 bg-secundarioMira rounded-sm shadow-sm ">
              <table className="min-w-full divide-y divide-grisMira p-5  shadow-sm shadow-grisMira">
                <thead className="sticky top-0 z-10 bg-secundarioMira ">
                  <tr className="w-full divide-x divide-grisMira ">
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Cuenta
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Fecha
                    </th>

                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Hora
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Descripción
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Boleta
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      Valor
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-grisMira bg-primarioMira w-full">
                  {dataNoCargados?.map((element, index) => (
                    <tr key={index} className={"divide-x divide-grisMira"}>
                      <td className=" whitespace-nowrap p-4 text-sm text-white text-center">
                        <p className={"m-auto"}>{element.Cuenta}</p>
                      </td>
                      <td className=" whitespace-nowrap p-4 text-sm text-white ">
                        {element.Fecha}
                      </td>

                      <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                        {element.Hora}
                      </td>

                      <td className=" whitespace-nowrap p-4 text-sm text-white ">
                        {element.Descrip}
                      </td>
                      <td className=" whitespace-nowrap p-4 text-sm text-white ">
                        {element.Boleta}
                      </td>
                      <td className=" whitespace-nowrap p-4 text-sm text-white ">
                        {element.Valor}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>{" "}
        </div>
      </WarningModal>
      <Layout userObj={userObj} activeTab="Subir archivo">
        <Container height="h-full">
          <Header title="Subir archivo" logo={ArrowUpTrayIcon} />
          <div className="w-full flex self-center justify-center flex-row">
            <div className="w-full /xl:w-[70%] rounded-md  shadow-smp-1 ">
              <div className="flex flex-col w-full shadow shadow-white rounded-md /mb-1">
                <div className="flex flex-row w-1/2 /justify-center">
                  <label className={"m-2 text-white"} htmlFor="EC">
                    Estados de cuenta
                  </label>
                  <input
                    className="my-auto"
                    type="radio"
                    value={1}
                    name={"EC"}
                    checked={option === 1 ? true : false}
                    onChange={() => setOption(1)}
                  ></input>
                  <label className={"m-2 text-white"} htmlFor="SAT">
                    Facturación SAT
                  </label>
                  <input
                    className="my-auto"
                    type="radio"
                    value={2}
                    name={"SAT"}
                    checked={option === 2 ? true : false}
                    onChange={() => setOption(2)}
                  ></input>
                </div>
                <div className="flex flex-row w-1/2 /justify-center p-2">
                  <p className="text-gray-400 /m-auto">
                    Para continuar, debe elegir una opción
                  </p>
                </div>
              </div>

              {option === 1 ? (
                <>
                  <div className="flex flex-row gap-2 bg-gray-700 rounded-md p-1 mt-2 elementFadeIn">
                    <div className="w-1/2 flex flex-col bg-primarioMira p-2 rounded-md">
                      <>
                        <h1 className="text-white font-medium text-xl xl:ml-4">
                          Bancos
                        </h1>
                        <h1 className="text-gray-400 text-md xl:ml-4">
                          Seleccione el banco al cual desea subir el estado de
                          cuenta
                        </h1>
                        <CirculosBancos
                          filter={filter}
                          setCuenta={setCuenta}
                          //handleCuenta={handleCuenta}
                          handleSede={handleSede}
                          banco={banco}
                          bancos={bancos}
                          cuentas={cuentas}
                        />
                        <h1 className="text-white xl:ml-4">
                          {bancos.length > 0 &&
                            bancos.find(
                              (element) => element?.IdBanco === banco
                            )["Nombre"]}
                        </h1>
                      </>
                    </div>
                    <div className="w-1/2 flex flex-col bg-primarioMira p-2 rounded-md">
                      {!cuenta ? (
                        <div className="">
                          <h1 className="text-white font-medium text-xl">
                            Cuentas
                          </h1>
                          <h1 className="text-gray-400 text-md mb-3">
                            Seleccione la cuenta a la cual desea subir el estado
                            de cuenta
                          </h1>
                          <div className=" grid grid-cols-4 gap-4 text-white">
                            {/* IdCuenta, Cuenta*/}
                            

                            {cuentas.map((e) => (
                              <div
                                className={classNames(
                                  e.IdCuenta === cuenta
                                    ? "shadow-white bg-azulBrillanteMira"
                                    : "flex flex-row m-auto gap-2  border border-gray-400 hover:cursor-pointer hover:shadow-white hover:bg-azulBrillanteMira hover:font-medium",
                                  " shadow-sm p-2 text-center rounded-md elementFadeIn ease transform transition duration-150"
                                )}
                                onClick={() =>
                                  handleCuenta(e.IdCuenta, e.Cuenta)
                                }
                              >
                                <ListBulletIcon className="text-white h-6 w-6"></ListBulletIcon>
                                {e.Cuenta}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="my-auto elementFadeIn">
                        <Transition
                          show={cuenta ? true : false}
                          enter="transform transition duration-[400ms]"
                          enterFrom="opacity-0"
                          enterTo="opacity-100 h-full flex flex-col gap-4 my-auto"
                          leave="transform duration-200 transition ease-in-out"
                          leaveFrom="opacity-100 rotate-0 scale-100 "
                          leaveTo="opacity-0 scale-95 "
                        >
                          <InputFile
                            setFileBase64={setFileBase64}
                            fileBase64={fileBase64}
                            cuenta={nombreCuenta}
                            banco={
                              bancos.length > 0 &&
                              bancos.find(
                                (element) => element?.IdBanco === banco
                              )["Nombre"]
                            }
                          />
                          {fileBase64 && (
                            <div className="flex w-full justify-end bg-primarioMira p-2 rounded-md my-auto elementFadeIn">
                              <button
                                onClick={() => sendFile()}
                                className="inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                              >
                                Subir archivo
                              </button>
                            </div>
                          )}
                        </Transition>
                          </div>
                      )}
                    </div>
                  </div>
                </>
              ) : null}



              {option === 2 ? (
                <>
                  <div className="flex flex-row gap-2 bg-gray-700 rounded-md p-1 mt-2 elementFadeIn">
                    {option === 2 && (
                      <>
                        <div className="w-1/2 flex flex-col bg-primarioMira p-2 rounded-md">
                            <div className="flex flex-row justify-center my-auto h-full">
                              <label className="inline text-sm font-medium text-grisMira my-auto mx-2">
                                Mes y año
                              </label>
                              <input
                                type="month"
                                min="2022-08"
                                max={currentMMYY()}
                                onChange={(e) => handleMes(e.target.value)}
                                name="mmyy"
                                // defaultValue={currentMMYY()}
                                className="my-auto /inline /w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>
                          </div>

                          <div className="w-1/2 flex flex-col bg-primarioMira p-2 rounded-md">
                            <Transition
                                show={mes ? true : false}
                                enter="transform transition duration-[400ms]"
                                enterFrom="opacity-0"
                                enterTo="opacity-100 h-full flex flex-col gap-4"
                                leave="transform duration-200 transition ease-in-out"
                                leaveFrom="opacity-100 rotate-0 scale-100 "
                                leaveTo="opacity-0 scale-95 "
                              >
                                <InputFile
                                  setFileBase64={setFileBase64}
                                  fileBase64={fileBase64}
                                  cuenta={nombreCuenta}
                                  mes={mes}
                                  banco={
                                    bancos.length > 0 &&
                                    bancos.find(
                                      (element) => element?.IdBanco === banco
                                    )["Nombre"]
                                  }
                                />
                                {fileBase64 && (
                                  <div className="flex w-full justify-end bg-primarioMira p-2 rounded-md">
                                    <button
                                      onClick={() => sendFile()}
                                      className="inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                                    >
                                      Subir archivo
                                    </button>
                                  </div>
                                )}
                              </Transition>
                          </div>
                      </>
                    )}
                    </div>
                </>
              ):null}

            </div>
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default ContabilidadArchivo;
